import { useState } from "react";
import axios from "axios";
import { Eye, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Plate Pin evidence button — admin-only inline preview.
 * Fetches the heavy thumbnail on demand (active-map list ships only the
 * `has_evidence` flag to keep payloads small) and toggles inline display.
 */
export default function EvidencePin({ alertId }) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    if (data) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/alerts/${alertId}/evidence`, { withCredentials: true });
      setData(res.data?.evidence_thumbnail || null);
    } catch {
      setData(null);
    }
    setLoading(false);
  };

  return (
    <div className="mt-1.5" data-testid={`evidence-pin-${alertId}`}>
      <button
        type="button"
        onClick={toggle}
        className="text-[10px] text-blue-700 hover:text-blue-900 font-body inline-flex items-center gap-1 underline-offset-2 hover:underline"
        data-testid={`evidence-toggle-${alertId}`}
      >
        <Eye className="w-3 h-3" /> {open ? t("alert_feed.hide_evidence") : t("alert_feed.view_evidence")}
      </button>
      {open && (
        <div className="mt-1.5 border border-gray-200 rounded-sm p-1 bg-gray-50">
          {loading ? (
            <div className="flex items-center gap-1 text-[10px] text-gray-400 py-2 px-1">
              <Loader2 className="w-3 h-3 animate-spin" /> Loading evidence...
            </div>
          ) : data ? (
            <img
              src={data}
              alt="Plate evidence"
              className="w-full max-h-28 object-contain rounded-sm"
              data-testid={`evidence-img-${alertId}`}
            />
          ) : (
            <p className="text-[10px] text-gray-400 py-2 px-1">Evidence not available</p>
          )}
        </div>
      )}
    </div>
  );
}
